import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { EstimationScale } from '../models/EstimationScale'
import { EstimationScaleForm } from '../forms/EstimationScaleForm'
import { EstimationScaleFilter } from '../filters/EstimationScaleFilter'
import { EstimationScaleService } from '../services/EstimationScaleService'

export const useEstimationScaleStore: KsStoreHook<EstimationScale, EstimationScaleForm, EstimationScaleFilter> = createKsStore({
  id: 'estimationScales',
  modelClass: EstimationScale,
  formClass: EstimationScaleForm,
  filterClass: EstimationScaleFilter,
  service: EstimationScaleService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Phase #${item.id}`,
  signalREventName: 'EstimationScaleModel',
  isReferential: true
})
